/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Runbook } from "./Runbook";
export const RunbookResponse = core.serialization.object({
    data: Runbook,
});
